import styled from "styled-components";

import { motion } from "framer-motion";

export default function ContentWrapper(props) {
  return (
    <ContentGrid introBuffer={props.introBuffer}>
      <ContentInner>{props.children}</ContentInner>
    </ContentGrid>
  );
}

const ContentGrid = styled(motion.div)`
  min-height: calc(100vh - var(--footerHeight) - var(--headerHeight));
  display: grid;
  grid-template-columns: var(--gridTemplateColumnsDefault);
  column-gap: var(--gridColumnGap);
  padding: var(--gridMarginGap);
  grid-template-areas: "a a a a a a";

  margin-top: ${(props) => (props.introBuffer ? "30vh" : 0)};

  @media screen and (min-width: 768px) {
    grid-template-areas: ". . a a a a a a a a . .";
  }

  @media screen and (min-width: 2400px) {
    max-width: 2400px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ContentInner = styled.div`
  grid-area: a;
`;
